import { MODULE_KEYS, FEATURE_KEYS, TELEMETRY_IDS, I18N_KEYS, ROUTE_IDS, OPERATION_IDS, } from '../routes/ids.js';
import { PLATFORM_ADMIN_HUB } from './platform-admin-hub.definition.js';
import { ORGANIZATION_ADMIN_HUB } from './organization-admin-hub.definition.js';
export const ADMIN_HUB = {
    id: 'hub.admin',
    schemaVersion: 1,
    module: MODULE_KEYS.ADMIN,
    feature: FEATURE_KEYS.NAVIGATION,
    telemetryId: TELEMETRY_IDS.HUB_ADMIN,
    accessibilityLabelKey: I18N_KEYS.HUB_ADMIN_ACCESSIBILITY,
    privacyClassification: 'INTERNAL',
    auditPolicy: 'NONE',
    owner: 'platform',
    hubRouteId: ROUTE_IDS.ADMIN_HUB,
    titleKey: I18N_KEYS.HUB_ADMIN_TITLE,
    descriptionKey: 'hub.admin.description',
    availability: 'AVAILABLE',
    operationId: OPERATION_IDS.ADMIN_HUB,
    groups: [...PLATFORM_ADMIN_HUB.groups, ...ORGANIZATION_ADMIN_HUB.groups],
};
